export class HostnamePublicModelPostRequest {
  hostname: string;
}
